module.exports = __webpack_public_path__ + "static/scale-model-of-aldo-leopold-nature-center-in-madison-wisconsin-5dbb10df1a5dbc42e763e6214ab9a37f.png";